export default __webpack_public_path__ + "53657cd0c49f116db9c8302f38c1248c.jpg";